import React from "react";
import "./PremiumLoader.css";

const PremiumLoader = ({ fullPage = true, text = "Loading..." }) => {
    return (
        <div className={`premium-loader-container ${!fullPage ? "section-mode" : ""}`}>
            <div className="loader-wrapper">
                <div className="loader-ring"></div>
                <div className="loader-ring"></div>
                <img src="/build/Logo.svg" alt="App Logo" className="loader-logo-img" />
            </div>
            {text && <div className="loading-text">{text}</div>}
        </div>
    );
};

export default PremiumLoader;
